import AccordionContainer from "../../components/uiKits/accordion";

const Accordion = () => {
  return <AccordionContainer />;
};

export default Accordion;
